import { useParams, useRouterState } from "@tanstack/react-router";

export const screenPaths = {
  home: "/",
  friends: "/friends",
  history: "/history",
  messages: "/messages",
  notifications: "/notifications",
  profile: "/profile",
} as const;
export type Screen = keyof typeof screenPaths;
const screens = Object.keys(screenPaths) as Screen[];

// The open view, chat, call link, profile link and the device sign-in code being
// approved all come from the path.
// Screens are route components, so naming this result keeps the router's type
// from depending on itself.
export function useAppLocation(): {
  screen: Screen;
  chatId: string | null;
  inviteId: string | null;
  profileCode: string | null;
  signInCode: string | null;
  groupCode: string | null;
} {
  // The matches, not the location, which updates ahead of what is rendered.
  const pathname = useRouterState({
    select: (state) =>
      (state.matches.at(-1)?.pathname ?? "/").replace(/(.)\/$/, "$1"),
  });
  const { personId, link, code, signInCode, groupCode } = useParams({
    strict: false,
  });
  return {
    screen: personId
      ? "messages"
      : (screens.find((screen) => screenPaths[screen] === pathname) ?? "home"),
    chatId: personId ?? null,
    inviteId: link?.toLowerCase() ?? null,
    profileCode: code?.toLowerCase() ?? null,
    signInCode: signInCode ?? null,
    groupCode: groupCode?.toLowerCase() ?? null,
  };
}
